import { useState, useEffect } from "react";

function useScrollHandler(scrollObject, id, gap = 0) {
  const [scrollDetails, setScrollDetails] = useState(scrollObject);

  useEffect(() => {
    const stickyElement = document.getElementById(id);
    const scrollActive =
      stickyElement.getBoundingClientRect().y + window.scrollY;
    function scrollHandler() {
      // console.log(stickyElement)
      if (
        !(stickyElement.getBoundingClientRect().bottom < -gap) &&
        !(stickyElement.getBoundingClientRect().top > gap)
      ) {
        if (stickyElement.getBoundingClientRect().y <= gap) {
          const widthResult = window.scrollY - scrollActive;
          setScrollDetails(() => {
            return {
              scrollCalc: widthResult,
              scroll: window.scrollY,
              active: true,
            };
          });
        }
      } else if (scrollDetails.active) {
        setScrollDetails({
          scrollCalc: 0,
          scroll: 0,
          active: false,
        });
      } else return;
    }

    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return scrollDetails;
}

export default useScrollHandler;
